"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.buttonDefaultSize = exports.buttonDefaultVariant = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SystemIcon = _interopRequireDefault(require("../../../protons/icons/SystemIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var colorIconMap = {
  primary: "white",
  secondary: "white",
  tertiary: "grey",
  selected: "white"
};
var sizeIconMap = {
  small: "small",
  medium: "default",
  large: "large"
};
/**
 * **Buttons allow users to take actions, and make choices, with a single tap.**
 *
 * There are 4 variants: Primary, Secondary, Tertiary, Selected
 *
 * There are 2 sizes: Medium, Small
 *
 * There are 2 states: Active, Disabled
 *
 * There is a full width variant and a left icon variant
 */

var ButtonDefault = function ButtonDefault(_ref) {
  var variant = _ref.variant,
      size = _ref.size,
      action = _ref.action,
      title = _ref.title,
      icon = _ref.icon,
      fullWidth = _ref.fullWidth,
      active = _ref.active,
      disabled = _ref.disabled;
  var themeProps = {
    "primary": {
      "variant": "contained",
      "color": "primary",
      "className": (0, _classnames.default)({
        "Mui-active": active
      }),
      classes: {
        startIcon: "MuiSvgIcon-colorWhite"
      }
    },
    "secondary": {
      "variant": "contained",
      "className": (0, _classnames.default)({
        "Mui-active": active
      })
    },
    "tertiary": {
      "variant": "outlined",
      "className": (0, _classnames.default)({
        "Mui-active": active
      })
    },
    "selected": {
      "variant": "contained",
      "className": (0, _classnames.default)({
        "MuiButton-containedSelected": true,
        "Mui-active": active
      })
    }
  };
  return /*#__PURE__*/_react.default.createElement(_Button.default, _extends({}, themeProps[variant], {
    onClick: function onClick(event) {
      return action && action(event);
    },
    size: size,
    fullWidth: fullWidth,
    disableElevation: true,
    disabled: disabled,
    startIcon: icon && /*#__PURE__*/_react.default.createElement(_SystemIcon.default, {
      icon: icon,
      color: colorIconMap[variant],
      size: sizeIconMap[size]
    })
  }), title);
};

ButtonDefault.propTypes = {
  /** The available colour variants of the button */
  variant: _propTypes.default.oneOf(['primary', 'secondary', 'tertiary', 'selected']),

  /** The available sizes of the button  (30px, 40px) */
  size: _propTypes.default.oneOf(['small', 'medium']),

  /** The title of the button */
  title: _propTypes.default.string.isRequired,

  /** A Full Width variant of the button  */
  fullWidth: _propTypes.default.bool,

  /** The active state of the button (Turquoise outline) */
  active: _propTypes.default.bool,

  /** The disable state of the button */
  disabled: _propTypes.default.bool,

  /** A left side icon option. (SystemIconKeys as value)  */
  icon: _propTypes.default.string,

  /** Action that will called on click */
  action: _propTypes.default.func.isRequired
};
ButtonDefault.defaultProps = {
  size: "medium",
  variant: "primary",
  fullWidth: false,
  active: false,
  disabled: false,
  icon: null
};
var buttonDefaultVariant = ['primary', 'secondary', 'tertiary', 'selected'];
exports.buttonDefaultVariant = buttonDefaultVariant;
var buttonDefaultSize = ['small', 'medium'];
exports.buttonDefaultSize = buttonDefaultSize;
var _default = ButtonDefault;
exports.default = _default;